/**
 * Kopyalanan kayıtların görseli (ürün, kampanya): form yeni kayıtta görseli
 * dosya olarak ister, kaynağınki ise bir URL. Medya herkese açık olduğundan
 * istek oturum anahtarı taşımaz (başka sunucuya JWT gitmesin).
 */
export async function fetchImageAsFile(
  url: string,
  baseName: string
): Promise<File> {
  const response = await fetch(url, { credentials: 'omit' });
  if (!response.ok) {
    throw new Error(`Image request failed: ${response.status}`);
  }
  const blob = await response.blob();
  const type = blob.type || 'image/jpeg';
  if (!type.startsWith('image/')) {
    throw new Error(`Not an image: ${type}`);
  }
  const extension = type.split('/')[1]?.split('+')[0] || 'jpg';
  const safeName =
    baseName
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'I')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .toLowerCase() || 'image';
  return new File([blob], `${safeName}.${extension}`, { type });
}
